<template>
  <material-card :title="$t('components.vuematerialdashboard.core.appbar.my_account')" :color="$vuetify.theme.themes.light.secondary" icon="account_circle">
    <v-container fluid v-if="this.user!==null && this.user!==undefined" grid-list-md>
      <v-switch color="primary" v-model="edit" :label="$t('globals.edit')" @change="onEditChange"></v-switch>
      <v-form v-model="namesValid">
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <no-autocomplete-textfield
              v-model="firstName"
              :disabled="!edit"
              ref="firstName"
              v-on:keyup="keymonitorFirstname"
              :rules="[$rules.required, $rules.validName]"
              :label="$t('globals.firstname')"
              class="required"
            ></no-autocomplete-textfield>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <no-autocomplete-textfield
              ref="lastName"
              v-model="lastName"
              :disabled="!edit"
              v-on:keyup="keymonitorLastname"
              :rules="[$rules.required, $rules.validLastName]"
              :label="$t('globals.lastname')"
              class="required"
            ></no-autocomplete-textfield>
          </v-flex>
          <v-flex xs12 sm6 md4 lg3>
            <v-btn
              :loading="namesSaving"
              :disabled="!(firstNameDirty || lastNameDirty) || !namesValid"
              v-on:click="save()"
              depressed
              small
              color="success"
            >
              <v-icon>check_circle</v-icon>
              {{$t('components.membersmanagementtable.apply_changes')}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 lg3>
          <no-autocomplete-textfield v-model="user.Email" :label="$t('headers.contacts.email')" :disabled="true"></no-autocomplete-textfield>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3>
          <no-autocomplete-textfield v-model="user.Broker.Name" :label="$t('globals.broker')" :disabled="true"></no-autocomplete-textfield>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3>
          <no-autocomplete-textfield
            v-model="registrationDate"
            :label="$t('views.myaccount.registration_date')"
            :disabled="true"
          ></no-autocomplete-textfield>
        </v-flex>
        <v-flex xs12>
          <div style="color:rgba(0, 0, 0, 0.38)">
            <b>{{"Plans: "}}</b>
            <span
              style="margin-left:5px"
              v-for="plan in userPlans"
              v-bind:key="plan.Id"
            >
              {{plan.Name}}
            </span>
          </div>
        </v-flex>
        <v-flex xs12>
          <div style="color:rgba(0, 0, 0, 0.38)">
            <b>{{"Tags: "}}</b>
            <span
              style="background-color: #e6e6e6; padding: 3px 5px; border-radius: 3px; margin: 0px 3px 0 5px"
              v-for="tag in userTags"
              v-bind:key="tag.Id"
            >
            {{tag.Name}}
            </span>
          </div>
        </v-flex>
        <v-flex xs12>
          <div style="color:rgba(0, 0, 0, 0.38)">
            <b>{{"Roles: "}}</b>
            <span
              style="margin-left:5px"
            >
              {{userRoles}}
              </span>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-form ref="passwordForm" v-model="passwordValid">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 lg3 v-if="!editPassword">
                  <v-btn
                    :disabled="!edit"
                    color="primary"
                    v-on:click="editPassword=true"
                  >{{$t('views.myaccount.change_password')}}</v-btn>
                </v-flex>
                <v-flex xs12 sm6 md4 lg3 v-if="editPassword">
                  <no-autocomplete-textfield
                    ref="password"
                    :disabled="!edit"
                    v-on:keyup="keymonitorPassword"
                    v-model="password"
                    :type="'password'"
                    :rules="$rules.passwordRules"
                    :label="$t('views.firstlogin.password')"
                  ></no-autocomplete-textfield>
                </v-flex>
                <v-flex xs12 sm6 md4 lg3 v-if="editPassword">
                  <no-autocomplete-textfield
                    ref="passwordConfirm"
                    autocomplete="new-password"
                    v-on:keyup="keymonitorPasswordConfirm"
                    v-model="passwordConfirm"
                    :type="'password'"
                    :rules="[$rules.dynamic.passwordsMatch(password)]"
                    :label="$t('views.firstlogin.password_confirmation')"
                  ></no-autocomplete-textfield>
                </v-flex>
                <v-flex xs12 sm6 md4 lg3 v-if="editPassword">
                  <v-btn
                    :loading="passwordSaving"
                    :disabled="!passwordDirty || !passwordValid"
                    v-on:click="savePassword"
                    depressed
                    small
                    color="success"
                  >
                    <v-icon>check_circle</v-icon>
                    {{$t('components.membersmanagementtable.apply_changes')}}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <!--<v-card-actions>
      <v-btn text @click="$router.push({name: 'home'})">{{$t('globals.cancel')}}</v-btn>
    </v-card-actions>-->
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{$t(message)}}
      <v-btn dark text @click="snackbar = false">{{$t('globals.close')}}</v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";

export default {
  name: "my-account",
  components: {
    ErrorHandler,
    NoAutocompleteTextfield
  },
  data() {
    return {
      error: null,
      roles: [],
      userRoles: "",
      userPlans: "",
      userTags: "",
      brokerId: null,
      registrationDate: null,
      user: null,
      editPassword: false,
      edit: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      namesValid: true,
      emailValid: true,
      passwordValid: true,
      firstName: "",
      lastName: "",
      password: "",
      passwordConfirm: null,
      firstNameDirty: false,
      lastNameDirty: false,
      passwordDirty: false,
      namesSaving: false,
      passwordSaving: false
    };
  },
  watch: {
    passwordConfirm: {
      handler() {
        this.$refs.password.error = false;
        this.validate();
      }
    },
    password :{
      handler() {
        if(this.passwordConfirm || (this.password && this.passwordConfirm)){
          this.passwordValid = false;
          this.$nextTick(() => {
            this.$refs.passwordForm.validate();
          });
        }
      }
    }
  },
  computed: {
    ...mapGetters("common", ["messages"]),
  },
  async mounted() {
    this.loading = true;
    try {
      var user = await this.getUser();
      //console.log(user);
      // eslint-disable-next-line
      var id = user.profile.sub;
      this.brokerId = user.profile.brokerid;
      this.user = (
        await this.getApplicationUser({
          broker: this.brokerId,
          user: id
        })
      ).data;
      //console.log(this.user.RegistrationDate);
      this.roles = (await this.getRoles()).data;
      this.firstName = this.user.FirstName;
      this.lastName = this.user.LastName;
      this.password = this.user.Password;
      var n = Date.parse(this.user.RegistrationDate);
      let date = new Date(n);
      this.registrationDate = date;
      this.userPlans = this.user.Plans;
      let itemRoles = [];
      this.user.Roles.forEach(itemRole => {
        let commonRoles = this.roles.filter(r => r.Id === itemRole.RoleId);
        if (commonRoles.length > 0) itemRoles.push(commonRoles[0]);
      });
      this.userRoles = itemRoles.map(r => r.Name).join(", ");
      //this.userTags = this.user.Plans.map(p => p.Tags).reduce((a,b)=> a.concat(b));
       this.userTags = [];
        let all = this.user.Plans.map(o => o.Tags).flat(1);
        
        this.userTags = [];
        for (const tag of all) {
          let missing = false;
          if (tag.Plans) {
            for (const tagPlan of tag.Plans) {
              if (this.user.Plans.filter(o => o.Id === tagPlan.Id).length === 0) {
                missing = true;
              }
            }
          } else {
            missing = true;
          }
          if (!missing) {
            if (this.userTags.filter(o => o.Id === tag.Id).length === 0) {
              this.userTags.push(tag);
            }
          }
        }
        
        this.userTags = this.userTags.sort((a, b) =>
          a.Name < b.Name ? -1 : 1
        );
        //console.log(this.userTags)
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("auth", ["getRoles", "getUser"]),
    ...mapActions("applicationUsers", ["updateUser", "resetPassword"]),
    ...mapActions("applicationUsers", { getApplicationUser: "getUser" }),
    onEditChange: function(newval) {
      if (!newval) {
        this.firstName = this.user.FirstName;
        this.lastName = this.user.LastName;
        this.editPassword = false;
      }
    },
    keymonitorLastname: function(event) {
      //console.log(event.key);
      if (event.key !== "Enter" && event.key !== "Tab") {
        this.lastNameDirty = true;
      }
    },
    keymonitorFirstname: function(event) {
      //console.log(event.key);
      if (event.key !== "Enter" && event.key !== "Tab") {
        this.firstNameDirty = true;
      }
    },
    keymonitorPassword: function(event) {
      //console.log(event.key);
      if (event.key !== "Enter" && event.key !== "Tab") {
        this.passwordDirty = true;
      }
    },
    keymonitorPasswordConfirm: function(event) {
      //console.log(event.key);
      if (event.key !== "Enter" && event.key !== "Tab") {
        this.passwordConfirmDirty = true;
      }
    },
    validate() {
      if (this.$refs.passwordForm.validate()) {
        return true;
      }
      return false;
    },
    async save() {
      try {
        this.namesSaving = true;
        this.user.FirstName = this.firstName;
        this.user.LastName = this.lastName;

        await this.updateUser({ broker: this.brokerId, user: this.user });

        this.namesSaving = false;
        this.firstNameDirty = false;
        this.lastNameDirty = false;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
      } catch (error) {
        this.error = error;
      }
    },
    async savePassword() {
      try {
        this.passwordSaving = true;
        await this.resetPassword({
          broker: this.brokerId,
          payload: { Id: this.user.Id, Password: this.password }
        });

        this.passwordSaving = false;
        this.passwordDirty = false;
        this.editPassword - false;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
      } catch (error) {
        this.error = error;
      }
    }
  }
};
</script>